import { Box } from "@mui/material";
import React from "react";
import styles from "../../styles/components/partnerListItem.module.scss";
// import Image from "next/image";
import assest from "../../json/assest";
// import Link from "next/link";

// interface PartnerListItemProps {
//     cardVideoCount: number;
//     cardVideoApprovedCount: number;
//     cardVideoRejectedCount: number;
//     cardVideoDuplicateCount: number;
// }

const PartnerListItem = (props) => {
    return (
        <Box className={styles.partnerLIstItem}>
            <Box className={styles.partnerItem}>
                <Box className={styles.partnerItemImg}>
                    <img
                        src={assest.partnerSubmissionIcon}
                        width={16}
                        height={16}
                        alt=""
                    />
                </Box>

                <Box className={styles.partnerItemTxt}>
                    <h5>All Submissions</h5>
                    <p>{props?.cardVideoCount}</p>
                </Box>
            </Box>
            <Box className={styles.partnerItem}>
                <Box className={styles.partnerItemImg}>
                    <img
                        src={assest.partnerApproveIcon}
                        width={16}
                        height={16}
                        alt=""
                    />
                </Box>

                <Box className={styles.partnerItemTxt}>
                    <h5>Approved Videos</h5>
                    <p>{props?.cardVideoApprovedCount}</p>
                </Box>
            </Box>
            <Box className={styles.partnerItem}>
                <Box className={styles.partnerItemImg}>
                    <img
                        src={assest.partnerRejectIcon}
                        width={16}
                        height={16}
                        alt=""
                    />
                </Box>

                <Box className={styles.partnerItemTxt}>
                    <h5>Rejected Videos</h5>
                    <p>{props?.cardVideoRejectedCount}</p>
                </Box>
            </Box>
            <Box className={styles.partnerItem}>
                <Box className={styles.partnerItemImg}>
                    <img
                        src={assest.partnerDuplicateIcon}
                        width={16}
                        height={16}
                        alt=""
                    />
                </Box>

                <Box className={styles.partnerItemTxt}>
                    <h5>Duplicate Videos</h5>
                    <p>{props?.cardVideoDuplicateCount}</p>
                </Box>
            </Box>
        </Box>
    );
};

export default PartnerListItem;
